import { useEffect, useMemo, useState } from "react";

/**
 * Keeps a stable visual row order after drag-and-drop until server `sortedItems`
 * reflects the new order (avoids snap-back while onLoad() is in flight).
 */
export function useOptimisticSubmissionOrder(sortedItems) {
  const serverOrderKey = useMemo(
    () => (sortedItems || []).map((i) => String(i?._id ?? "")).join("|"),
    [sortedItems]
  );

  const [optimisticRows, setOptimisticRows] = useState(null);

  useEffect(() => {
    setOptimisticRows(null);
  }, [serverOrderKey]);

  const rowsToShow = optimisticRows ?? sortedItems ?? [];

  return {
    rowsToShow,
    setOptimisticRows,
    clearOptimisticRows: () => setOptimisticRows(null),
  };
}
